import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import "../styles/SignIn.css"
import google from "../images/google.png"
import axios from "axios";
import CircularProgress from '@mui/material/CircularProgress';
import { message } from "antd";
import { Checkbox, Form, Input } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import {  KeyOutlined} from '@ant-design/icons';
import { Button } from "@mui/material";
import { initializeApp } from "firebase/app";
import { getMessaging,getToken  } from "firebase/messaging";
import * as  firebase from 'firebase/app';

export default function SignIn ({setUserData}) {
  
    const [loading,setLoading]=useState(false)
    let navigate=useNavigate()

    
  const [errorMessage,setErrorMessage]=message.useMessage();
  const [messageApi, contextHolder] = message.useMessage();
   //successfull message
   const success = () => {
    messageApi.open({
      type: 'success',
      content: 'successfuly logged in',
      duration: 3,
    });
      setTimeout(()=>{
        window.location.href = "/";
      },2000)
  };
  
  //errror message
  const Error = (message) => {
   errorMessage.open({
     type: 'error',
     content: message,
     duration: 2,
   });
 
  };

  let [token,setToken]=useState(localStorage.getItem("FCM_TOKEN"))
    const onFinish = async(values) => {
      setLoading(true)
      values['fcm_token']=token
      let stringfy=JSON.stringify(values)
      axios.post(`${process.env.REACT_APP_URL}/api/user/logIn`,stringfy,{
        headers: {
          authorization:`xxxxxxxx`,
          'Content-Type': 'application/json'
        }
      })
       .then(function (response) {
        setLoading(false)
        setUserData(response.data)
        console.log(response.data);
          success()
      }).catch((error) => {
        console.log(error);
        setLoading(false)
        if (error.response) {
          Error(error.response.data.error||"Error occured, please try again")
        } else if (error.request) {
          Error("Error occured, please try again")
        } else {
          Error("Error occured, please try again")
        }
        
      });
   }
  
    const onFinishFailed = (errorInfo) => {
      //console.log('Failed:', errorInfo);
    };

  

    return (
        <>
          {setErrorMessage}
          {contextHolder}
        <div className="signin-container">
            <div className="signin-header">
              <div>Sign In</div>
            </div>
            <div className="signin-form">
                <Form
                  layout="vertical"
                  name="basic"
                  labelCol={{
                    span: 28,
                  }}
                  wrapperCol={{
                    span: 86,
                  }}
                  style={{
                    Width:800,
                  }}
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
            >
                <Form.Item
                    name="email_Or_username"
                    rules={[
                      {
                        required: true,
                        message: '',
                      },
                    ]}
                  >
                  <Input size="middle"  placeholder="email or username"  prefix={<UserOutlined />} />
                </Form.Item>
               
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: '',
                      },
                    ]}
                  >
                    <Input.Password size="middle" placeholder="password" prefix={<KeyOutlined />} />    
                  </Form.Item>

                  <Form.Item
                 
                  >
                {loading?  <div className="signin-form-button"><CircularProgress size={24} color="success"/></div>: 
                <div className="signin-form-button"><button  htmlType="submit" >Sign In</button></div>
                }
                  
                  </Form.Item>
                </Form>
                <div>  
                  <p className="signin-form-paragraph">Don't have an account ?  <Link to="/SignUp" className="signup-link">Sign Up</Link></p>
                 
                </div>

                <div className="signin-footer">
                  <Button>
                      <div><img src={google} className="google-icon" /></div>
                      <div>Sign in with Google</div>
                  </Button>
                </div>

             </div>
        </div>
        </>
      );
}


